import axiosInstance from "../lib/axiosInstance";

class events {

    constructor() {
        this.base_url = "/event"
    }
    async list(query = []) {

        return (await axiosInstance.get(`${this.base_url}?${new URLSearchParams(query)}`)).data;
    }
}
    export default new events();